import React from 'react';
import { Href } from '../../components';
import { CONTENT_TYPES_SITE } from '../../constants';
export var DefaultContentTypeComponent = function (_a) {
    var type = _a.type;
    return (React.createElement("div", null,
        React.createElement(Href, { href: CONTENT_TYPES_SITE + "/" + type },
            React.createElement("span", null, type))));
};
//# sourceMappingURL=DefaultContentType.js.map